(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  function prefillCorporateGift() {
    const gift = new URLSearchParams(window.location.search).get('gift');
    const form = document.querySelector('#corporate-enquiry form');
    if (!gift || !form) return;
    const field = Array.from(form.elements).find(input => input.name === 'contact[Preferred gift box]');
    if (field && !field.value) field.value = gift.slice(0, 160);
  }
  prefillCorporateGift();
  document.addEventListener('shopify:section:load', prefillCorporateGift);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbb-diwali-range"] && !Shopify.designMode) return;
  try {
    
  function initializeDiwaliRange(root) {
    if (root.dataset.filtersReady) return;
    root.dataset.filtersReady = 'true';
    const controls = root.querySelector('.tbb-diwali__filters');
    const cards = Array.from(root.querySelectorAll('[data-gift-budget]'));
    const count = root.querySelector('[data-gift-count]');
    const empty = root.querySelector('[data-gift-empty]');
    const countTemplate = count.textContent.replace(/\d+/, '{count}');
    const buttons = Array.from(controls.querySelectorAll('button'));
    function filter(budget) {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = budget !== 'all' && card.dataset.giftBudget !== budget;
        if (!card.hidden) visible += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.budget === budget)));
      count.textContent = countTemplate.replace('{count}', String(visible));
      empty.hidden = visible !== 0;
    }
    controls.hidden = false;
    filter('all');
    controls.addEventListener('click', event => {
      const button = event.target.closest('button[data-budget]');
      if (!button) return;
      filter(button.dataset.budget);
      const url = new URL(location.href);
      if (button.dataset.budget === 'all') url.searchParams.delete('budget');
      else url.searchParams.set('budget', button.dataset.budget);
      history.replaceState(null, '', url);
    });
    const initialBudget = new URL(location.href).searchParams.get('budget');
    if (buttons.some(button => button.dataset.budget === initialBudget)) filter(initialBudget);
  }
  document.querySelectorAll('[data-diwali-range]').forEach(initializeDiwaliRange);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-diwali-range]').forEach(initializeDiwaliRange);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbb-gift-collection-grid"] && !Shopify.designMode) return;
  try {
    
  function initializeGiftBrowsers(scope) {
    scope.querySelectorAll('[data-gift-browser]').forEach((browser) => {
      if (browser.dataset.giftInitialized) return;
      browser.dataset.giftInitialized = 'true';
      const controls = browser.querySelector('[data-gift-budget]');
      if (!controls) return;
      const select = controls.querySelector('[data-gift-budget-select]');
      const status = controls.querySelector('[data-gift-results]');
      const cards = Array.from(browser.querySelectorAll('[data-gift-product]'));
      const update = () => {
        const all = select.value === 'all';
        controls.querySelector('.tbb-gift-native__budget-note').hidden = all;
        const [minimum, maximum] = select.value.split(':').map(Number);
        let count = 0;
        cards.forEach((card) => {
          const prices = card.dataset.giftPrices.split(',').filter(Boolean).map(Number);
          const matches = all || prices.some((price) => Number.isFinite(price) && price > minimum && price <= maximum);
          card.hidden = !matches;
          if (matches) count += 1;
        });
        status.textContent = browser.dataset.resultTemplate.replace('[[count]]', String(count));
        const carousel = browser.querySelector('.swiper');
        if (carousel && carousel.swiper) {
          carousel.swiper.update();
          carousel.swiper.slideTo(0, 0);
        }
      };
      select.addEventListener('change', update);
      controls.hidden = false;
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGiftBrowsers(document));
  } else {
    initializeGiftBrowsers(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeGiftBrowsers(event.target));

  } catch(e) { console.error(e); }
})();
})();
